module.exports = __webpack_public_path__ + "static/media/nft1.82809103.png";